module.exports = __webpack_public_path__ + "img/2024-02-13e_1.2c0895c5.jpg";